import clsx from 'clsx';
import React, { ReactNode, useEffect, useState } from 'react';

import ArrowUp from '~/images/shared/ArrowUp.svg';

interface Props {
  children: ReactNode;
  header: ReactNode;
  containerClassName?: string;
  childrenClassName?: string;
  itemClassName?: string;
  open?: boolean;
  defaultValue?: boolean;
  bgColor?: string;
  borderRadius?: string;
  clickableArea?: 'whole' | 'arrow';
  containerPadding?: string;
  childrenPadding?: string;
  arrowStyle?: string;
  isLink?: boolean;
  handleShowCollapseContent?: (updatedValue: boolean) => void;
}

// TODO: refactor this
const Collapse: React.FC<Props> = ({
  children,
  header,
  containerClassName,
  handleShowCollapseContent,
  itemClassName,
  borderRadius,
  clickableArea = 'whole',
  bgColor,
  containerPadding,
  childrenClassName,
  childrenPadding,
  open,
  defaultValue,
  arrowStyle,
  isLink,
}) => {
  const [showCollapseContent, setShowCollapseContent] = useState(
    open || defaultValue
  );
  useEffect(() => {
    setShowCollapseContent(open || defaultValue);
  }, [open, defaultValue]);

  const toggleCollapseContent = () => {
    if (open === undefined) {
      const updatedValue = !showCollapseContent;
      setShowCollapseContent(updatedValue);
      if (handleShowCollapseContent) handleShowCollapseContent(updatedValue);
    }
  };

  const containerStyle = clsx(
    'flex w-full flex-col',
    borderRadius || 'rounded-lg',
    containerClassName
  );
  const itemStyle = clsx(
    'flex items-center justify-between',
    clickableArea === 'whole' && 'cursor-pointer',
    borderRadius || 'rounded-lg',
    containerPadding || ' p-16',
    bgColor || 'border-b-background-neutral-100 bg-white',
    itemClassName
  );
  const childrenStyle = clsx(
    childrenClassName,
    childrenPadding ? childrenPadding : 'p-16'
  );

  const arrowClasses = clsx(
    'transition',
    arrowStyle,
    clickableArea === 'arrow' && 'cursor-pointer',
    !showCollapseContent && 'rotate-180'
  );

  return (
    <div className={containerStyle}>
      <div
        className={itemStyle}
        onClick={clickableArea === 'whole' ? toggleCollapseContent : undefined}
      >
        {isLink ? (
          <div onClick={(e) => e.stopPropagation()}>{header}</div>
        ) : (
          <>{header}</>
        )}
        <span
          onClick={
            clickableArea === 'arrow' ? toggleCollapseContent : undefined
          }
          className={arrowClasses}
        >
          <ArrowUp />
        </span>
      </div>
      {showCollapseContent && <div className={childrenStyle}>{children}</div>}
    </div>
  );
};
export default Collapse;

Collapse.defaultProps = {
  itemClassName: '',
  containerClassName: '',
  // open: false,
  arrowStyle: 'text-20 text-primary-default',
};
